export const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_ORG_DETAIL':
      return { ...state, orgDetail: action.payload }
    default:
      return state
  }
}
